export default "__VITE_ASSET__ad6b847b__"